const module = { name: 'movie/shared/desktop/movieStateUI', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context_movieDetails_pageDetails } from 'require-core';

const { context, movieDetails, pageDetails } = Fandango_context_movieDetails_pageDetails;


import { global_consts as global_consts_CookieNames_QueryParams } from 'require-core';

const { CookieNames, QueryParams } = global_consts_CookieNames_QueryParams;


import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from 'require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { Fandango_cookie as Fandango_cookie_get_getCookie } from 'require-core';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { fd_location as fd_location_getLocation } from 'require-global';

const { getLocation } = fd_location_getLocation;


import { Fandango_queryUtil as Fandango_queryUtil_getParam } from 'require-core';

const { getParam } = Fandango_queryUtil_getParam;


import { global_utils_functionUtils as global_utils_functionUtils_noop } from 'require-global';

const { noop } = global_utils_functionUtils_noop;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_sanitizer as sanitizer } from 'require-core';



import { default as calendarUI } from 'swug-fdRequire-call:movie/shared/calendarUI';



import { default as featuredShowtimeUI } from 'swug-fdRequire-call:movie/shared/desktop/featuredShowtimeUI';



import { default as spinner } from 'swug-fdRequire-call:movie/shared/desktop/spinner';



import { default as worker } from 'swug-fdRequire-call:shared/movies/movieState.worker';



let isShowtimesPage = false


let isDesktopMOP = false
function readPageContext(context, movieDetails, pageDetails) {
    const { id, number } = sanitizer;
    const isMobile = Boolean(context.device.isMobile);
    const { mopUrlZip } = pageDetails;
    return {
        movie: movieDetails || {},
        request: {
            chainCode: id(getParam(QueryParams.CHAIN_ID) || getCookie(CookieNames.CHAIN_CODE)) || null,
            date: dateFromQuery('d'),
            isDesktop: !isMobile,
            isMobile,
            location: mopUrlZip ? { params: { lat: null, long: null }, postalCode: mopUrlZip } : getLocation(),
            page: number(getParam(QueryParams.PAGE)),
        },
    };
}
function onWorkerDone(status, err, results) {
    spinner.stop();
    const { StatusTypes } = worker;
    if (status !== StatusTypes.SUCCESS) {
        debugLog.error(`${module.name}.onDone`, err);
        if (!isDesktopMOP) {
            featuredShowtimeUI.error();
        }
        return;
    }
    const { movieAttribs: { hideDateFormatSelection }, movie, showtimes } = results;
    const { hasShowtimes } = showtimes;
    if (hasShowtimes && !isShowtimesPage && !isDesktopMOP) {
        const { calendar: { selectedDate }, movieState: { isPreSaleDesktopLegacy } } = results;
        featuredShowtimeUI.done({ selectedDate, movie, showtimes, isPreSaleDesktopLegacy });
    }
    if (isDesktopMOP && hideDateFormatSelection) {
        calendarUI.hide();
    }
}
function run(opts) {
    opts = opts || {};
    const pageContext = readPageContext(context, movieDetails, pageDetails);
    isDesktopMOP = Boolean(opts.isDesktopMOP);
    isShowtimesPage = Boolean(opts.isShowtimesPage);
    Object.assign(pageContext.request, {
        isDesktopMOP
    });
    const { onDone, onCalendarChange, onInitialize, onShowtimesChange } = noop(opts, 'onDone', 'onCalendarChange', 'onInitialize', 'onShowtimesChange');
    onInitialize(pageContext);
    worker.run({
        ...pageContext,
        onCalendarChange() {
            onCalendarChange.apply(this, arguments);
        },
        onShowtimesChange() {
            onShowtimesChange.apply(this, arguments);
        },
        onDone() {
            onWorkerDone.apply(this, arguments);
            onDone.apply(null, arguments);
        },
    });
}
function update(opts) {
    worker.update(opts);
}
module.exports = {
    run,
    update,
};
export default module.exports;